import { CardDeckTrait, CreateCardDeckTraitData } from "@olagg/db-types"
import { AdminCardDecksTraitsEndpoints } from "../endpoints/adminEndpoints"
import { fetcher } from "../fetcher"
import { useToast } from "@chakra-ui/react"
import { useQ } from "./useQ"
import { useState } from "react"

export const useAdminCardDecksTraits = (deckId: string | number) => {
  const toast = useToast();
  const [trait, setTrait] = useState<CardDeckTrait>();

  const response = useQ<{traits: CardDeckTrait[]}>(AdminCardDecksTraitsEndpoints.list(deckId));

  const success_toast = (description: string) => {
    toast({
      title: 'Rasgo de Mazo',
      colorScheme: 'olaggPink',
      status: 'success',
      description,
      position: 'bottom-right'
    });
  }
  
  const error_toast = (error: any) => {
    toast({
      title: 'Error',
      colorScheme: 'olaggYellow',
      status: 'error',
      description: error.errors,
      position: 'bottom-right'
    });
  }

  const createTrait = async (data: CreateCardDeckTraitData, callback?: () => void) => {
    return await fetcher(AdminCardDecksTraitsEndpoints.create(deckId, { trait: data }))
      .then(() => {
        success_toast('Rasgo creado con éxito');
        response.mutate();
        callback?.();
      })
      .catch((error: any) => {
        error_toast(error);
      })
  }

  const updateTrait = async (traitId: string | number, data: Partial<CreateCardDeckTraitData>, callback?: () => void) => {
    return await fetcher(AdminCardDecksTraitsEndpoints.update(deckId, traitId, { trait: data }))
      .then(() => {
        success_toast('Rasgo actualizado con éxito');
        response.mutate();
        callback?.();
      })
      .catch((error: any) => {
        error_toast(error);
      })
  }

  const deleteTrait = async (traitId: string | number) => (
    fetcher(AdminCardDecksTraitsEndpoints.delete(deckId, traitId))
      .then(() => {
        success_toast('Rasgo eliminado con éxito');
        response.mutate();
      })
      .catch((error: any) => {
        error_toast(error);
      })
  )

  const find = (traitId: string | number) => {
    fetcher(AdminCardDecksTraitsEndpoints.show(deckId, traitId))
      .then(res => setTrait(res.trait))
  }

  return {
    ...response,
    trait,
    find,
    createTrait,
    updateTrait,
    deleteTrait,
  }
} 